import React, { Component } from 'react';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../../i18n/getLocale';

class ScheduleGradeTrainingsTab extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      loaded: 0,
      schedule_staff_trainings: this.props.schedule_staff_trainings,
    };

    this.locale = getLocale();
  }
  // LM
  componentWillReceiveProps(newProps) {
    if((this.state.loaded === 0 && Array.isArray(newProps.schedule_staff_trainings)) || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        schedule_staff_trainings: newProps.schedule_staff_trainings,
        loaded: 1,
      });
    }
  }
  
  render() {
    var self = this;
    return (
<div>
  <h3 className="page-title">{this.locale.GradesDeEscala.EditarGradeDeEscala.tabTreinamentos.tituloTreinamentosPresenciaisDosTripulantesEscalados}</h3>
  <hr/>
  {(this.state.schedule_staff_trainings === null || typeof this.state.schedule_staff_trainings === 'undefined') ?  <div><small><em>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabTreinamentos.naoHaTreinamentos}</em></small><hr/></div> 
  : 
    <BootstrapTable data={this.state.schedule_staff_trainings} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.GradesDeEscala.EditarGradeDeEscala.tabTreinamentos.tabela.semTreinamentos}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

      <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabTreinamentos.tabela.ID}</TableHeaderColumn>
      <TableHeaderColumn dataField="inscription" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabTreinamentos.tabela.Matricula}</TableHeaderColumn>
      <TableHeaderColumn dataField="nickname" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabTreinamentos.tabela.NomeDeGuerra}</TableHeaderColumn>
      <TableHeaderColumn dataField="training" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabTreinamentos.tabela.Treinamento}</TableHeaderColumn>
      <TableHeaderColumn dataField="code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabTreinamentos.tabela.Codigo}</TableHeaderColumn>
      <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabTreinamentos.tabela.Inicio}</TableHeaderColumn>
      <TableHeaderColumn dataField="date_finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.GradesDeEscala.EditarGradeDeEscala.tabTreinamentos.tabela.Fim}</TableHeaderColumn>
    </BootstrapTable>
  }

</div>
    );
  }
}


export default ScheduleGradeTrainingsTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeTrainingsTab.js